import React from 'react';
import { equals, ifElse } from 'ramda';

import { getTarget, getWithPrefix } from '../../utils';
import footerContent from './footer.data.json';
import { SOCIALS_ICONS } from './socials.component';
import {
  Container,
  Main,
  CategoriesList,
  Category,
  CategoryTitle,
  CategoryLinksList,
  CategoryItem,
  CategoryLink,
  SocialsList,
  SocialItem,
  SocialLink,
  ExtrasList,
  ExtraItem,
  ExtraLink,
  CategoriesListMobile,
  HalfWrapper,
} from './footer.styles';
import { useBreakpointsContext } from '../../store/BreakpointsContext';
import { divideCategoriesOnMobile, orderCategories } from './footer.utils';
import { useIntl } from 'gatsby-plugin-intl';

const renderSocialItem = ({ title, icon, url }, index) => (
  <SocialItem key={index}>
    <SocialLink href={url} title={title} target="_blank">
      {SOCIALS_ICONS[icon]}
    </SocialLink>
  </SocialItem>
);

const renderSocialsList = (socials = []) => <SocialsList>{socials.map(renderSocialItem)}</SocialsList>;

const renderExtraItem = ({ title, url }, index) => {
  const intl = useIntl();
  return (
    <ExtraItem key={index}>
      <ExtraLink href={url} title={title} target="_blank">
        {intl.formatMessage({ id: title })}
      </ExtraLink>
    </ExtraItem>
  );
};

const renderExtrasList = (extras = []) => <ExtrasList>{extras.map(renderExtraItem)}</ExtrasList>;

export const Footer = ({ handleLinkClick, className }) => {
  const { isDesktop } = useBreakpointsContext();
  const intl = useIntl();

  const renderCategoryItem = ({ title, url }, index) => {
    const linkProps = ifElse(
      equals('open-about'),
      () => ({
        onClick: handleLinkClick,
      }),
      (href) => ({
        href: getWithPrefix(href),
        target: getTarget(href),
      })
    )(url);

    return (
      <CategoryItem key={index}>
        <CategoryLink title={title} {...linkProps}>
          {intl.formatMessage({ id: title })}
        </CategoryLink>
      </CategoryItem>
    );
  };

  const renderCategory = ({ title, links }, index) => {
    const intl = useIntl();

    return (
      <Category key={index}>
        <CategoryTitle>{intl.formatMessage({ id: title })}</CategoryTitle>
        <CategoryLinksList>{links.map(renderCategoryItem)}</CategoryLinksList>
      </Category>
    );
  };

  const renderCategoriesList = (categories = []) => {
    const orderedCategories = orderCategories(isDesktop, categories);

    if (isDesktop) return <CategoriesList>{orderedCategories.map(renderCategory)}</CategoriesList>;

    const [firstHalf, secondHalf] = divideCategoriesOnMobile(categories);

    return (
      <CategoriesListMobile>
        <HalfWrapper>{firstHalf.map(renderCategory)}</HalfWrapper>
        <HalfWrapper>{secondHalf.map(renderCategory)}</HalfWrapper>
      </CategoriesListMobile>
    );
  };

  return (
    <Container className={className}>
      <Main>
        {renderCategoriesList(footerContent.categories)}
        {renderExtrasList(footerContent.extras)}
      </Main>

      {renderSocialsList(footerContent.socials)}
    </Container>
  );
};
